module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex/store_images/5@2x_bb6c8bd88618150240803ab585f1b921.png";